/* ============
 * Vuex Store
 * ============
 *
 * The store of the application
 *
 * http://vuex.vuejs.org/en/index.html
 */

import Vue from 'vue';
import Vuex from 'vuex';
import createLogger from 'vuex/dist/logger';
import * as actions from './actions/';

// Modules
import account from './modules/account';
import auth from 'features/authentication/authentication.store';
import courses from './modules/courses';
import roundtables from 'features/onlineRoundtables/onlineRoundtables.store';
import liveDiscussions from './modules/liveDiscussions';
import adminPortal from './modules/adminPortal';
import analytics from 'features/analytics/analytics.store';
import { environment } from 'services/apiConfigs';

Vue.use(Vuex);
const debug = environment !== 'production';

const clone = (el) => JSON.parse(JSON.stringify(el));

// Clone the initial state to use it in case of logout
const defaultState = {
  account: clone(account.state),
  auth: clone(auth.state),
  courses: clone(courses.state),
  roundtables: clone(roundtables.state),
  liveDiscussions: clone(liveDiscussions.state),
  adminPortal: clone(adminPortal.state),
};

const getDefaultState = () => clone(defaultState);

const vStore = new Vuex.Store({
  mutations: {
    // Used for resetting state on user logout
    RESET_STATE(state) {
      Object.assign(state, getDefaultState());
    },
    toggleSidebar(state) {
      state.globalStateSidebar.isOpen = !state.globalStateSidebar.isOpen;
    },
    closeSidebar(state) {
      state.globalStateSidebar.isOpen = false;
    },
    setCurrentPageSidebar(state, page) {
      state.globalStateSidebar.menuSelected = page;
    },
    setIsFromNotification(state, isFromNotification) {
      state.isFromNotification = isFromNotification;
    },
    // If you need force reload your component, just call this method in your component
    setIsReloadComponent(state) {
      state.isReloadComponent = Math.floor(Math.random() * 101);
    },
    setFecthComponent(state, isToFecth) {
      state.isToFecth = isToFecth;
    },
    setScrollPosition(state, position) {
      state.scrollPosition = position;
    }
  },
  state: {
    globalStateSidebar: { isOpen: window.innerWidth < 1024 ? false : true, menuSelected: 'dashboard' },
    isFromNotification: false,
    isReloadComponent: 0,
    isToFecth: false,
    scrollPosition: 0,
    course_sample_id: environment === 'production' ? '151035ea-b4c7-484d-a07d-3505fa895cf7' : '00fda91f-c168-44a8-a3bb-24c01dbdd72b',
  },
  /**
   * Assign the actions to the store
   */
  actions: actions.default,
  /**
   * Assign the modules to the store
   */
  modules: {
    account,
    auth,
    analytics,
    courses,
    roundtables,
    liveDiscussions,
    adminPortal,
  },
  /**
   * If strict mode should be enabled
   */
  strict: debug,
  /**
   * Plugins used in the store
   */
  plugins: debug ? [createLogger()] : [],

});

export default vStore;



// WEBPACK FOOTER //
// ./src/app/store/index.js